import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./index.css";
import "./i18n/config";
import { LanguageProvider } from "./contexts/LanguageContext";
import Default from "./pages/404";
import About from "./pages/About";
import Acknowledgement from "./pages/Acknowledgement";
import Annotate from "./pages/dashboard/AnnotateTab";
import Compare from "./pages/dashboard/annotate/Compare";
import GenerateGeneral from "./pages/dashboard/annotate/GenerateGeneral";
import GenerateTechnical from "./pages/dashboard/annotate/GenerateTechnical";
import MergeMetadata from "./pages/dashboard/annotate/MergeMetadata";
import Dashboard from "./pages/dashboard/Dashboard";
import Publish from "./pages/dashboard/PublishTab";
import PublishTool from "./pages/dashboard/publish/PublishTool";
import Schema from "./pages/dashboard/Schema";
import Home from "./pages/Home";
import Layout from "./pages/Layout";
import DashboardLayout from "./pages/LayoutDashboard";
import LegalPage from "./pages/LegalPage";
import Resodate from "./pages/Resodate";
import reportWebVitals from "./reportWebVitals";
import { routes } from "./routes";

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <Routes>
          <Route path={routes.home} element={<Layout />}>
            <Route index element={<Home />} />
            <Route path={routes.resodate} element={<Resodate />} />
            <Route path={routes.about} element={<About />} />
            <Route path={routes.imprint} element={<LegalPage />} />
            <Route path={routes.privacyPolicy} element={<LegalPage />} />
            <Route
              path={routes.acknowledgement}
              element={<Acknowledgement />}
            />
            <Route path="*" element={<Default />} />
          </Route>
          <Route
            path={routes.dashboard}
            element={<DashboardLayout bg="rgb(var(--color-dashboard-bg))" />}
          >
            <Route index element={<Dashboard />} />
            <Route path={routes.schema.relative}>
              <Route index element={<Schema />} />
              <Route
                path="archive"
                element={<Navigate to={routes.schema.absolute} replace />}
              />
            </Route>

            <Route path={routes.annotationTools.relative}>
              <Route index element={<Annotate />} />
              <Route
                path={routes.annotationTechnical.relative}
                element={<GenerateTechnical />}
              />
              <Route
                path={routes.annotationGeneral.relative}
                element={<GenerateGeneral />}
              />
              <Route
                path={routes.compareMetadata.relative}
                element={<Compare />}
              />
              <Route
                path={routes.mergeMetadata.relative}
                element={<MergeMetadata />}
              />
            </Route>

            <Route path={routes.publicationTools.relative}>
              <Route index element={<Publish />} />
              <Route
                path={routes.publishGitHub.relative}
                element={<PublishTool page="github" />}
              />
            </Route>

            <Route path="*" element={<Default />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
